import React from "react";
import { CheckCircle2, Clock, EyeOff, MessageSquareReply, Trash2 } from "lucide-react";

const btn = "inline-flex items-center gap-1.5 border px-2.5 py-1.5 text-[10px] uppercase tracking-widest transition-colors disabled:opacity-50";

export function ReviewStatusChip({ status }) {
  if (!status || status === "published") return null;
  const pending = status === "pending";
  return (
    <span
      data-testid="review-status-chip"
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] uppercase tracking-widest ${pending ? "bg-amber-50 text-amber-700" : "bg-stone-100 text-stone-600"}`}
    >
      {pending ? <Clock size={11} /> : <EyeOff size={11} />} {pending ? "Pending approval" : "Hidden"}
    </span>
  );
}

export function AdminReviewControls({ review, admin }) {
  const { status, reply } = review;
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-dashed border-border pt-3" data-testid="review-admin-controls">
      <span className="mr-auto text-[10px] uppercase tracking-widest text-gold">Admin</span>
      {status !== "published" && (
        <button type="button" onClick={() => admin.setStatus(review, "published")} disabled={admin.isUpdating} data-testid="review-approve-button" className={`${btn} border-emerald-600/40 text-emerald-700 hover:bg-emerald-600 hover:text-white`}>
          <CheckCircle2 size={13} /> Approve
        </button>
      )}
      {status !== "hidden" && (
        <button type="button" onClick={() => admin.setStatus(review, "hidden")} disabled={admin.isUpdating} data-testid="review-hide-button" className={`${btn} border-border text-muted-foreground hover:border-ink hover:text-ink`}>
          <EyeOff size={13} /> Hide
        </button>
      )}
      <button type="button" onClick={() => admin.setReplyTarget(review)} data-testid="review-reply-button" className={`${btn} border-border text-muted-foreground hover:border-gold hover:text-gold`}>
        <MessageSquareReply size={13} /> {reply ? "Edit reply" : "Reply"}
      </button>
      <button type="button" onClick={() => admin.setPendingDelete(review)} data-testid="review-delete-button" className={`${btn} border-border text-muted-foreground hover:border-red-500 hover:text-red-600`}>
        <Trash2 size={13} /> Delete
      </button>
    </div>
  );
}
